<div class="add-container">
	<h1 class="add-title">Adaugă o cerere</h1>
	<form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Subiect</mat-label>
                    <input type="text" matInput formControlName="subject" />
                    <mat-error *ngIf="!form.controls['subject'].valid && form.controls['subject'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Prioritate</mat-label>
                    <mat-select formControlName="id_cerere_priority">
                        <mat-option *ngFor="let priority of requestPriorities$ | async" [value]="priority.id">
                            {{ priority.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['id_cerere_priority'].valid && form.controls['id_cerere_priority'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Departament</mat-label>
                    <mat-select formControlName="id_departament" (selectionChange)="onDepartamentChange($event.value)">
                        <mat-option *ngFor="let departament of departamente$" [value]="departament.id_compartiment">
                            {{ departament.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['id_departament'].valid && form.controls['id_departament'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
       
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Tip</mat-label>
                    <mat-select formControlName="id_cerere_type">
                        <mat-option *ngFor="let tip of tipuri$ | async" [value]="tip.id">
                            {{ tip.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['id_cerere_type'].valid && form.controls['id_cerere_type'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Operator</mat-label>
                    <mat-select formControlName="id_user_assigned">
                        <mat-option *ngFor="let user of usersActive" [value]="user.id">
                            {{ user.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="container__upload d-flex flex-column">
            <div class="container__upload-header d-flex flex-row justify-content-between align-items-center">
                <p class="m-0">Fotografii/Documente</p>
                <button type="button" class="upload-btn" (click)="fileInput.click()">
                    <mat-icon class="upload-icon">cloud_upload</mat-icon>
                    ÎNCARCĂ
                </button>
            </div>
            <div class="container__upload-files" *ngIf="form.value.files && form.value.files.length > 0">
                <div class="container__upload-file d-flex flex-row justify-content-between align-items-center" *ngFor="let uploadedFile of form.value.files; let i = index">
                    <span class="container__upload-file-name">
                        {{ (uploadedFile.name && uploadedFile.name.length > 50) ? (uploadedFile.name | slice: 0:50) + '..' : (uploadedFile.name) }}
                    </span>

                    <mat-spinner diameter="32" *ngIf="uploading[i]"></mat-spinner>
                    <div>
                        <button class="container__upload-file-delete d-flex" type="button" matTooltip="Șterge fișierul încărcat" (click)="removeFile(i)">
                            <img class="btn-img" src="../../../assets/icons/delete.svg" alt="" />
                        </button>
                    </div>
                </div>
            </div>

            <input type="file" accept="image/png, image/jpeg, image/gif, image/jpg, application/pdf" id="upload-file-input-0" #fileInput
                name="fileInput" (change)="addFile($event)" multiple style="display: none">
        </div>
        
        <div class="row mt-2">
            <div class="col">
                <strong class="m-0">Cetățean</strong>
                <mat-checkbox formControlName="check_cetatean" color="primary"></mat-checkbox>
            </div>
        </div>
        
        <div *ngIf="this.form.get('check_cetatean')?.value">
            <div class="row">
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Denumire</mat-label>
                        <input type="text" matInput formControlName="cet_denumire" />
                    </mat-form-field>
                </div>
    
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>CUI</mat-label>
                        <input type="text" matInput formControlName="cet_cui" />
                    </mat-form-field>
                </div>
    
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Nume</mat-label>
                        <input type="text" matInput formControlName="cet_nume" />
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Prenume</mat-label>
                        <input type="text" matInput formControlName="cet_prenume" />
                    </mat-form-field>
                </div>
    
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Telefon</mat-label>
                        <input type="text" matInput formControlName="cet_telefon" />
                    </mat-form-field>
                </div>
    
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Email</mat-label>
                        <input type="text" matInput formControlName="cet_email" />
                    </mat-form-field>
                </div>
            </div>
            
            <div class="row">
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>CNP</mat-label>
                        <input type="text" matInput formControlName="cet_cnp" />
                    </mat-form-field>
                </div>
    
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>CI Serie</mat-label>
                        <input type="text" matInput formControlName="cet_ci_serie" />
                    </mat-form-field>
                </div>
    
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>CI Număr</mat-label>
                        <input type="text" matInput formControlName="cet_ci_numar" />
                    </mat-form-field>
                </div>
            </div>
            
            <div class="row">
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Județ</mat-label>
                        <mat-select matSelect formControlName="cet_adr_judet">
                            <mat-option value="-1">-- Alegeți --</mat-option>
                            <mat-option *ngFor="let judet of judete" [value]="judet.id">
                                {{ judet.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Oraș</mat-label>
                        <input type="text" matInput formControlName="cet_adr_oras" />
                    </mat-form-field>
                </div>
    
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Sector</mat-label>
                        <mat-select matSelect formControlName="cet_adr_sector">
                            <mat-option value="-1">-- Alegeți --</mat-option>
                            <mat-option value="1">Sector 1</mat-option>
                            <mat-option value="2">Sector 2</mat-option>
                            <mat-option value="3">Sector 3</mat-option>
                            <mat-option value="4">Sector 4</mat-option>
                            <mat-option value="5">Sector 5</mat-option>
                            <mat-option value="6">Sector 6</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            
            <div class="row">
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Strada</mat-label>
                        <input type="text" matInput formControlName="cet_adr_strada" />
                    </mat-form-field>
                </div>

                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Număr</mat-label>
                        <input type="text" matInput formControlName="cet_adr_numar" />
                    </mat-form-field>
                </div>
    
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Bloc</mat-label>
                        <input type="text" matInput formControlName="cet_adr_bloc" />
                    </mat-form-field>
                </div>
            </div>
            
            <div class="row">
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Scara</mat-label>
                        <input type="text" matInput formControlName="cet_adr_scara" />
                    </mat-form-field>
                </div>

                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Etaj</mat-label>
                        <input type="text" matInput formControlName="cet_adr_etaj" />
                    </mat-form-field>
                </div>
    
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Apartament</mat-label>
                        <input type="text" matInput formControlName="cet_adr_apartament" />
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Observații</mat-label>
                        <input type="text" matInput formControlName="cet_adr_observatii" />
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col">
                <h4>Descriere</h4>
                <angular-editor formControlName="description" [config]="editorConfig"></angular-editor>
                <mat-error *ngIf="!form.controls['description'].valid && form.controls['description'].touched">
                    Câmp obligatoriu
                </mat-error>
            </div>
        </div>
		
		<div class="row mt-3">
            <div class="col d-flex justify-content-end">
              <button class="buttons me-2" type="button" mat-flat-button (click)="closeDialog()">
                {{ helper.dialogConfig.buttonLabels.close }}
              </button>
              <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
                {{ helper.dialogConfig.buttonLabels.save }}
              </button>
            </div>
          </div>
	</form>
	<div class="section-spinner position-absolute" *ngIf="isLoading">
		<div class="spinner position-absolute top-50 start-50 translate-middle">
			<mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
		</div>
	</div>
</div>